// extracted by mini-css-extract-plugin
module.exports = {"option":"_18387867","input":"_563ff81f","label":"f9d93f4f","answer":"_9cc74113","correct":"_3614a059","answerLabel":"_134a248b","answerLabelCorrect":"_52c515bf"};